import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import type {
    OrderCommandCommon} from "@@/shared/orders/commands/order-commands-common";
import {
    orderCommandCommonZodSchema,
} from "@@/shared/orders/commands/order-commands-common";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type OrderFulfillRevertCommand = OrderCommandCommon & {
    readonly _type: "ORDER_FULFILL_REVERT_COMMAND";
};

type FactoryParams = Except<
    OrderFulfillRevertCommand,
    "_id" | "_type" | "_createdAt"
>;
const orderFulfillRevertCommandFactory = (params: FactoryParams) => {
    const orderFulfillReverted: OrderFulfillRevertCommand = {
        ...params,
        _id: generateId({ prefix: "order_fulfill_revert_command__" }),
        _type: "ORDER_FULFILL_REVERT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return orderFulfillReverted;
};

const orderFulfillRevertCommandZodSchema: z.ZodSchema<OrderFulfillRevertCommand> =
    orderCommandCommonZodSchema.and(
        z.object({
            _type: z.literal("ORDER_FULFILL_REVERT_COMMAND"),
        }),
    );

export { orderFulfillRevertCommandFactory, orderFulfillRevertCommandZodSchema };
export type { OrderFulfillRevertCommand };
